import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlRatsitCompaniesQueryVariables = Types.Exact<{
  name: Types.Scalars['String']['input'];
  includeCompanyCode?: Types.InputMaybe<Array<Types.GqlRatsitCompanyCode> | Types.GqlRatsitCompanyCode>;
}>;


export type GqlRatsitCompaniesQuery = { ratsitCompanies: Array<{ name: string, identityNumberKind: number, identityNumber: string, address?: string | null, countryCode?: string | null, juridicalKind: number, functionCode?: string | null, functionText?: string | null }> };

export type GqlCreateCompaniesStepOneQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GqlCreateCompaniesStepOneQuery = { currentUser: { admin: boolean, companyLimit?: number | null }, companies: Array<{ id: string, name: string, organizationNumber: string }>, companySuggestions: Array<{ id: string, name: string, organizationNumber: string, functions: Array<Types.GqlCompanySuggestionFunction>, userId: string, createdAt: string, updatedAt: string }> };


export const RatsitCompaniesDocument = gql`
    query RatsitCompanies($name: String!, $includeCompanyCode: [RatsitCompanyCode!]) {
  ratsitCompanies(name: $name, includeCompanyCode: $includeCompanyCode) {
    name
    identityNumberKind
    identityNumber
    address
    countryCode
    juridicalKind
    functionCode
    functionText
  }
}
    `;

/**
 * __useRatsitCompaniesQuery__
 *
 * To run a query within a React component, call `useRatsitCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatsitCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatsitCompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *      includeCompanyCode: // value for 'includeCompanyCode'
 *   },
 * });
 */
export function useRatsitCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables> & ({ variables: GqlRatsitCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>(RatsitCompaniesDocument, options);
      }
export function useRatsitCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>(RatsitCompaniesDocument, options);
        }
export function useRatsitCompaniesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>(RatsitCompaniesDocument, options);
        }
export type RatsitCompaniesQueryHookResult = ReturnType<typeof useRatsitCompaniesQuery>;
export type RatsitCompaniesLazyQueryHookResult = ReturnType<typeof useRatsitCompaniesLazyQuery>;
export type RatsitCompaniesSuspenseQueryHookResult = ReturnType<typeof useRatsitCompaniesSuspenseQuery>;
export type RatsitCompaniesQueryResult = Apollo.QueryResult<GqlRatsitCompaniesQuery, GqlRatsitCompaniesQueryVariables>;
export const CreateCompaniesStepOneDocument = gql`
    query CreateCompaniesStepOne {
  currentUser {
    admin
    companyLimit
  }
  companies {
    id
    name
    organizationNumber
  }
  companySuggestions {
    id
    name
    organizationNumber
    functions
    userId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useCreateCompaniesStepOneQuery__
 *
 * To run a query within a React component, call `useCreateCompaniesStepOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCompaniesStepOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCompaniesStepOneQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateCompaniesStepOneQuery(baseOptions?: Apollo.QueryHookOptions<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>(CreateCompaniesStepOneDocument, options);
      }
export function useCreateCompaniesStepOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>(CreateCompaniesStepOneDocument, options);
        }
export function useCreateCompaniesStepOneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>(CreateCompaniesStepOneDocument, options);
        }
export type CreateCompaniesStepOneQueryHookResult = ReturnType<typeof useCreateCompaniesStepOneQuery>;
export type CreateCompaniesStepOneLazyQueryHookResult = ReturnType<typeof useCreateCompaniesStepOneLazyQuery>;
export type CreateCompaniesStepOneSuspenseQueryHookResult = ReturnType<typeof useCreateCompaniesStepOneSuspenseQuery>;
export type CreateCompaniesStepOneQueryResult = Apollo.QueryResult<GqlCreateCompaniesStepOneQuery, GqlCreateCompaniesStepOneQueryVariables>;